export default __webpack_public_path__ + "static/Entenda0057-ad10afa6b0506534d1a7097a543ff377.jpg";